import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { TREATMENTS } from '../data/content';

const cats = ['All', 'Skin Diseases', 'Hair Problems', 'Pain Problems', 'Other Diseases'];

const treatmentImageById = {
  'acne-pimples':         'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/acne.jpg',
  'eczema-allergy':       'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/eczema.jpg',
  'psoriasis':            'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/psoriosis.jpg',
  'leucoderma':           'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/vitiligo.jpg',
  'hair-fall':            'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/hairfall.jpg',
  'grey-dry-hair':        'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/greyhair.jpg',
  'hair-loss-baldness':   'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/hairloss.jpg',
  'dandruff':             'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/dandruff.jpg',
  'cervical-spondylitis': 'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/spine.jpg',
  'lumbar-spondylitis':   'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/backpain.jpeg',
  'bone-muscular-pain':   'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/bone-n-muscle.jpg',
  'knee-pain-arthritis':  'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/knee.jpg',
  'frozen-shoulder':      'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/frozen-sholder.jpg',
  'sciatica':             'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/scatia.jpg',
  'paralysis':            'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/paraplegia.jpg',
  'migraine':             'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/migrane.jpg',
  'depression-anxiety':   'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/depression.jpg',
  'sinusitis':            'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/sinusitis.webp',
  'asthma-bronchitis':    'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/asthma.webp',
  'obesity':              'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/obsity.jpg',
  'renal-calculi':        'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/renal.jpg',
  'thyroid':              'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/thyroid.jpg',
  'diabetes':             'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/diabetes.jpg',
  'pcod':                 'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/hormones.jpg',
  'piles':                'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/piles-disease.webp',
  'insomnia':             'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/insomnia.jpg',
};

export default function Treatments() {
  const [active, setActive] = useState('All');
  const filtered = active === 'All' ? TREATMENTS : TREATMENTS.filter(t => t.category === active);

  return (
    <div style={{ background: '#1E1108', paddingTop: '68px', minHeight: '100vh' }}>
      <Helmet>
        <title>Ayurveda Treatment in Bhopal | Ayurveda Doctor near me</title>
        <meta name="description" content="Ayurvedic treatments in Bhopal for skin diseases, hair problems, pain, diabetes, obesity & more. Kerala certified care by Dr. Monika Jain." />
      </Helmet>

      <div style={{ padding: '70px 48px 40px', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
        <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
          <span style={{ fontSize: '10px', letterSpacing: '3px', color: '#C8941A', textTransform: 'uppercase', fontWeight: 500, display: 'block', marginBottom: '14px' }}>Conditions We Treat</span>
          <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '62px', color: '#F0E6D8', lineHeight: 1.05, marginBottom: '18px' }}>Treatments</h1>
          <p style={{ fontSize: '16px', color: 'rgba(240,230,216,0.4)', maxWidth: '500px', lineHeight: 1.8 }}>Authentic Ayurvedic care for 26+ conditions, rooted in classical Kerala Panchakarma tradition.</p>
        </div>
      </div>

      {/* Category tabs */}
      <div style={{ padding: '24px 48px', borderBottom: '1px solid rgba(255,255,255,0.05)', position: 'sticky', top: '68px', background: 'rgba(18,8,2,0.95)', backdropFilter: 'blur(20px)', zIndex: 100 }}>
        <div style={{ maxWidth: '1280px', margin: '0 auto', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {cats.map(cat => (
            <button key={cat} onClick={() => setActive(cat)} style={{
              background: active === cat ? '#C8941A' : 'transparent',
              color: active === cat ? '#120800' : 'rgba(240,230,216,0.45)',
              border: active === cat ? 'none' : '1px solid rgba(255,255,255,0.1)',
              borderRadius: '3px', padding: '8px 20px', fontSize: '12px',
              letterSpacing: '0.3px', cursor: 'pointer', transition: 'all 0.2s',
              fontFamily: 'DM Sans, sans-serif', fontWeight: active === cat ? 600 : 400,
            }}>{cat}</button>
          ))}
        </div>
      </div>

      {/* Grid */}
      <div style={{ padding: '2px 48px 100px', maxWidth: '1328px', margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '2px', marginTop: '2px' }}>
          {filtered.map((t) => (
            <Link to={`/treatments/${t.id}`} key={t.id}
              style={{ display: 'block', position: 'relative', height: '320px', overflow: 'hidden', textDecoration: 'none', background: '#261408' }}
              onMouseEnter={e => e.currentTarget.querySelector('img').style.transform = 'scale(1.06)'}
              onMouseLeave={e => e.currentTarget.querySelector('img').style.transform = 'scale(1)'}
            >
              <img src={treatmentImageById[t.id] || 'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/therapies/shirodhara.jpg'} alt={t.name}
                style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.7s cubic-bezier(0.4,0,0.2,1)' }} />
              <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top,rgba(18,8,2,0.92) 0%,rgba(18,8,2,0.25) 55%,transparent 100%)' }} />
              <div style={{ position: 'absolute', bottom: 0, padding: '26px 22px' }}>
                <div style={{ fontSize: '9px', letterSpacing: '2px', color: 'rgba(200,148,26,0.75)', textTransform: 'uppercase', marginBottom: '5px' }}>{t.category}</div>
                <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '24px', color: '#F0E6D8', marginBottom: '5px' }}>{t.name}</div>
                <div style={{ fontSize: '12px', color: 'rgba(240,230,216,0.4)', lineHeight: 1.6 }}>{t.tagline}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
